import './index.css'
import Hero from './components/Hero'
import ComprehensiveSolutions from './components/sections/ComprehensiveSolutions'
import ClientStaffManagement from './components/sections/ClientStaffManagement'
import Newsletter from './components/Newsletter'
import Footer from './components/Footer'
import ScrollProgress from './components/ScrollProgress'
import SocialProof from './components/sections/SocialProof'
import FeatureShowcase from './components/sections/FeatureShowcase'
import PlatformExplorer from './components/PlatformExplorer'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { WebsiteProvider, useWebsite } from './contexts/WebsiteContext';
import { Toaster } from './components/ui/toaster';


// Component to render the main website with ordered sections
function MainWebsite() {
  const { sections } = useWebsite();

  // Map section IDs to their components
  const sectionComponents: { [key: string]: React.ComponentType } = {
    'hero': Hero,
    'social-proof': SocialProof,
    'comprehensive-solutions': ComprehensiveSolutions,
    'feature-showcase': FeatureShowcase,
    'client-staff-management': ClientStaffManagement,
    'platform-explorer': PlatformExplorer,
    'newsletter': Newsletter,
  };

  // Debug logging
  // console.log('All sections:', sections);
  // console.log('Filtered and sorted sections:', 
   //   sections
   //     .filter(section => section.is_active)
   //     .sort((a, b) => ((a.order_index ?? 0) - (b.order_index ?? 0)))
   // );

  return (
    <>
      <ScrollProgress />
      {sections
        .filter(section => section.is_active)
        .sort((a, b) => ((a.order_index ?? 0) - (b.order_index ?? 0)))
        .map(section => {
          //console.log('Rendering section:', section.section_id, 
          //  'Component exists:', !!sectionComponents[section.section_id]);
          const Component = sectionComponents[section.section_id];
          return Component ? <Component key={section.id} /> : null;
        })}
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <WebsiteProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<MainWebsite />} />
          </Routes>
          <Toaster />
        </WebsiteProvider>
      </AuthProvider>
    </Router>
  )
}

export default App
